<div *ngIf="reportType === 'Indetail'" id="print-section">
    <div class="table-responsive">
        <table class="table table-bordered table-sm" style="background-color: white; color: black; border: 1px solid black;">
            
            <!-- Report Header -->
            <thead>
                <tr>
                    <th colspan="3" style="border: 2px solid #0a0a0a; text-align: center; padding: 8px; font-weight: bold;font-size: 16px;">
                        Hindustan - Vivek Saptahik
                    </th>
                    <th colspan="3" style="border: 2px solid #0a0a0a; text-align: center; padding: 8px; font-weight: bold;font-size: 16px;">
                        Advt. Stamp Register
                    </th>
                    <th colspan="3" style="border: 2px solid #0a0a0a; text-align: center; padding: 8px; font-weight: bold;font-size: 16px;">
                        Date: From {{startDate | date: "dd-MM-yyyy"}} To {{endDate | date: "dd-MM-yyyy"}}
                    </th>
                    <!-- <th colspan="1" style="border: 2px solid #0a0a0a; text-align: center; padding: 8px; font-weight: bold;font-size: 16px;">
                
                    </th> -->
                </tr>
                
                <!-- Column Headers -->
                <tr style="background-color: #f8f9fa;">
                    <th style="border: 1px solid black; padding: 8px; text-align: center;font-size: 14px;">Advt Name</th>
                    <th style="border: 1px solid black; padding: 8px; text-align: center;font-size: 14px;">Receipt No</th>
                    <th style="border: 1px solid black; padding: 8px; text-align: center;font-size: 14px;">Receipt<br>Date</th>
                    <th style="border: 1px solid black; padding: 8px; text-align: center;font-size: 14px;">Rep Name</th>
                    <th style="border: 1px solid black; padding: 8px; text-align: center;font-size: 14px;">OffRep Name</th>
                    <th style="border: 1px solid black; padding: 8px; text-align: center;font-size: 14px;">Issue Name</th>
                    <th style="border: 1px solid black; padding: 8px; text-align: center;font-size: 14px;">Issue Date</th>
                    <th style="border: 1px solid black; padding: 8px; text-align: center;font-size: 14px;">Invoice No</th>
                    <th style="border: 1px solid black; padding: 8px; text-align: center;font-size: 14px;">Amount</th>
                </tr>
            </thead>

            <!-- Table Body -->
            <tbody>
                <tr *ngFor="let s of stampdata">
                    <td style="border: 1px solid black; padding: 6px;font-size: 14px;">{{ s.advt_name }}</td>      
                    <td style="border: 1px solid black; padding: 6px;font-size: 14px;">{{ s.receipt_no }}</td>
                    <td style="border: 1px solid black; padding: 6px;font-size: 14px;">{{ s.receipt_date | date:'dd-MM-yyyy' }}</td>
                    <td style="border: 1px solid black; padding: 6px;font-size: 14px;">{{ s.rep_name }}</td>
                    <td style="border: 1px solid black; padding: 6px;font-size: 14px;">{{ s.offRepName }}</td>
                    <td style="border: 1px solid black; padding: 6px;font-size: 14px;">{{ s.issueName }}</td>
                    <td style="border: 1px solid black; padding: 6px;font-size: 14px;">{{ s.issueDate | date:'dd-MM-yyyy' }}</td>
                    <td style="border: 1px solid black; padding: 6px;font-size: 14px;">{{ s.invoice_no }}</td>
                    <td style="border: 1px solid black; padding: 6px;font-size: 14px; text-align: right;">{{ s.amt }}</td>
                </tr>

                <!-- No Data -->
                <tr *ngIf="stampdata.length === 0">
                    <td colspan="9" style="border: 1px solid black; padding: 12px; text-align: center; color: red; font-weight: bold;">
                        No Data Found
                    </td>
                </tr>
            </tbody>

            <!-- Footer -->
            <tfoot *ngIf="stampdata.length > 0">
                <tr style="background-color: #f8f9fa; font-weight: bold;">
                    <td colspan="8" style="border: 1px solid black; padding: 8px; text-align: right;font-size: 16px;">
                        <b>Total:</b>
                    </td>
                    <td style="border: 1px solid black; padding: 8px; text-align: right;font-size: 16px;">
                        <b>{{ getTotalAmount() }}</b>
                    </td>
                </tr>
            </tfoot>

        </table>
    </div>

    <div class="noPrint" style="margin-left: 80%; margin-bottom: 2%">
        <button style="margin-top: 2%;" mat-raised-button color="primary"
            (click)="exportExcel('Stamp_register Report')">
            Export
        </button>

        <button style="margin-top: 2%;" mat-raised-button color="primary"
            (click)="printPageA3Portrait()">
            Print
        </button>

        <button mat-dialog-close class="btn">Close</button>
    </div>
</div>
